export const setScroll = {
  computed: {
    setScroll() {
      const height = this.clientHeight + 200;
      document.body.style.overflowY = "hidden";
      if (height > this.windowHeight) {
        document
          .getElementById("pinwallHtml")
          .setAttribute("style", "overflow-y:hidden !important");
        return `height: ${this.windowHeight -
          60}px;overflow-y:auto;overflow-x:hidden;`;
      } else {
        document
          .getElementById("pinwallHtml")
          .setAttribute("style", "overflow-y:auto !important");
      }
      return "";
    }
  },
  beforeDestroy() {
    document
      .getElementById("pinwallHtml")
      .setAttribute("style", "overflow-y:auto !important");
  }
};
